<template>
    <flex-element
        :element-type="elementType"
        tag="div"
        class="f-flex"
        @click="emitClickEvent"
    >
        <font-awesome-icon :icon="[renderSet, renderIcon]" :class="iconClasses" />
    </flex-element>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import baseAtom from '@/mixins/base-atom/base-atom-smart';
import { AIcon } from '@/data/data-models';

export default {
    name: 'a-icon',
    components: { FontAwesomeIcon },
    mixins: [baseAtom],

    props: {
        displayName: {
            type: String,
            default: 'Icon',
        },

        set: {
            type: String,
            default: '',
        },

        icon: {
            type: String,
            default: '',
        },

        setDefault: {
            type: String,
            default: 'fal',
        },

        iconDefault: {
            type: String,
            default: 'smile',
        },

        templateId: {
            type: String,
            default: '{2EA7C12C-C037-4355-8F52-D6711854D62A}',
        },
    },

    data() {
        return {
            cssDisplay: 'block',
            iconNew: '',
            setNew: '',
        };
    },

    computed: {
        iconClasses() {
            return this.htmlClass.filter(className => className.includes('f-rounded'));
        },

        renderSet() {
            return this.setNew || this.setDefault;
        },

        renderIcon() {
            return this.iconNew || this.iconDefault;
        },

        updatedElement() {
            return new AIcon({
                ...this.updatedBaseElement,
                set: this.setNew,
                icon: this.iconNew,
            });
        },
    },

    watch: {
        icon() {
            this.setFieldValues();
        },
    },

    methods: {
        setFieldValues() {
            this.setNew = this.set;
            this.iconNew = this.icon;
        },

        emitClickEvent(e) {
            this.$emit('click', e);
        },
    },
};
</script>
